var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    "data-name": "Group 27691"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5903"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.185 145.825 26.829-19.16 42.08 58.86-14.31 10.048",
    "data-name": "Path 32609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.356 176.365 9.932-5.348 64.465 10.474a19.467 19.467 0 0 0 13.872-2.995l58.981-39.159a11.415 11.415 0 0 0 3.194-15.815h0a11.407 11.407 0 0 0-15.815-3.187L170.3 139.829",
    "data-name": "Path 32612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.958 135.508 35.192-22.653a12.134 12.134 0 0 1 9.8-1.49l70.34 19.494a11.409 11.409 0 0 1 7.942 14.035h0a11.4 11.4 0 0 1-14.032 7.943h0l-45.277-12.538",
    "data-name": "Path 32613"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5904"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.602 52.84c-10.51 12.692-8.442 25.782-1.961 31.152s19.734 4.97 30.247-7.722 7.822-38.239 7.822-38.239-25.598 2.118-36.108 14.809z",
    "data-name": "Path 32614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14 17.809c10.513 12.695 8.435 25.783 1.953 31.152s-19.729 4.97-30.24-7.722-7.828-38.235-7.828-38.235 25.605 2.114 36.115 14.805z",
    "data-name": "Path 32615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.669 56.691c-7.244 6.631-13.262 17.191-18.118 28.6-6.317 14.8-10.56 30.909-12.948 41.241",
    "data-name": "Path 32616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.678 125.989c.542-21.426-.692-37.769-7.166-60.357a100.644 100.644 0 0 0-6.168-16.107A101.938 101.938 0 0 0 102.3 22.002",
    "data-name": "Path 32617"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.25a154e2cc59d50651020fcb24314c38.svg";
export { ForwardRef as ReactComponent };